import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import TopBar from './TopBar'
import { useIndietro } from '../lib/navigazioneIndietro'
import { comeLista } from '../lib/formati'

const CATEGORIE = ['Corpo libero','Calisthenics','Pesistica','Kettlebell','Cardio','Mobilità','CrossFit','Animal Flow']
const ATTREZZATURE = [
  'Ab wheel', 'Abdominal crunch machine', 'Abductor', 'Adductor', 'Arm curl machine', 'Arm extension',
  'Calf machine', 'Chest press', 'Glute press', 'Hip thrust machine', 'Lat machine',
  'Lateral raise machine', 'Leg curl', 'Leg extension', 'Leg press', 'Low row', 'Lower back',
  'Multi flight', 'Multi hip', 'Multi-station', 'Multipower', 'Panca Scott', 'Pectoral machine',
  'Prone leg curl', 'Pulldown', 'Pulley', 'Reverse fly', 'Rotary torso', 'Shoulder press',
  'Standing calf', 'Total abdominal', 'Triceps press machine', 'Upper back', 'Upper body', 'Vertical traction',
]
const COL = {
  'Corpo libero': { bg: 'rgba(200,255,87,0.12)', text: 'var(--accent)' },
  'Calisthenics': { bg: 'rgba(255,217,61,0.12)', text: 'var(--yellow)' },
  'Pesistica': { bg: 'rgba(87,184,255,0.12)', text: 'var(--accent2)' },
  'Kettlebell': { bg: 'rgba(255,120,87,0.12)', text: 'var(--accent3)' },
  'Cardio': { bg: 'rgba(74,222,128,0.12)', text: 'var(--green)' },
  'Mobilità': { bg: 'rgba(199,125,255,0.12)', text: 'var(--purple)' },
  'CrossFit': { bg: 'rgba(255,120,87,0.12)', text: 'var(--accent3)' },
  'Animal Flow': { bg: 'rgba(199,125,255,0.12)', text: 'var(--purple)' },
}

export default function LibreriaEsercizi({ modalitaScelta = false, onScelto, onChiudi, modaleSelezione = false, esercizioSelezionato, esercizioSelezionatoIds = [], onAvviaOra }) {
  const { profilo, esci } = useAuth()
  const isAdmin = profilo?.piano === 'admin'
  const [esercizi, setEsercizi] = useState([])
  const [preferiti, setPreferiti] = useState([])
  const [cerca, setCerca] = useState('')
  const [catFiltro, setCatFiltro] = useState(null)
  const [attrezzoScelto, setAttrezzoScelto] = useState(null) // solo modalità picker: filtro semplice
  const [attrezzoPagina, setAttrezzoPagina] = useState(null) // solo modalità standalone: attrezzo di cui si vede la pagina esercizi
  const [esercizioAvvio, setEsercizioAvvio] = useState(null) // esercizio in fase di configurazione (carico/elastico) prima di avviare
  const [caricoAvvio, setCaricoAvvio] = useState('')
  const [usaElasticoAvvio, setUsaElasticoAvvio] = useState(false)
  const [elasticoAvvio, setElasticoAvvio] = useState('')
  const [tab, setTab] = useState('tutti')
  const [dettaglio, setDettaglio] = useState(null)
  const [livelloScelto, setLivelloScelto] = useState(null) // esercizio/variante attualmente selezionato nella pagina dettaglio

  // Tasto indietro: chiude la pagina attrezzo e il dettaglio esercizio come le
  // rispettive frecce, invece di uscire dall'app o chiudere tutta la libreria
  useIndietro(!!attrezzoPagina, () => setAttrezzoPagina(null))
  useIndietro(!!dettaglio, () => { setDettaglio(null); setLivelloScelto(null) })
  const [toast, setToast] = useState('')
  const [mostraForm, setMostraForm] = useState(false)
  const [modificaId, setModificaId] = useState(null)
  const [caricamento, setCaricamento] = useState(true)
  const [nuovoEx, setNuovoEx] = useState({ nome: '', categoria: 'Corpo libero', muscoli: '', qualita: '', tipo_misura: 'ripetizioni', supporta_sovraccarico: false, descrizione: '', difficolta: 3, video_url: '', attrezzatura: [], consente_elastico: false })

  useEffect(() => { caricaDati() }, [])

  // Se l'atleta è tornato in libreria dopo aver avviato una sessione da qui, riapri il dettaglio dell'esercizio corrispondente
  // (invece di lasciarlo sulla lista generale). L'id è salvato in sessionStorage subito prima dell'avvio.
  useEffect(() => {
    if (esercizi.length === 0) return
    const riapri = sessionStorage.getItem('fp_libreria_riapri_dettaglio')
    if (!riapri) return
    sessionStorage.removeItem('fp_libreria_riapri_dettaglio')
    try {
      const { baseId, selId } = JSON.parse(riapri)
      const base = esercizi.find(e => e.id === baseId)
      if (base) {
        setDettaglio(base)
        if (selId && selId !== baseId) {
          const sel = esercizi.find(e => e.id === selId)
          if (sel) setLivelloScelto(sel)
        }
      }
    } catch {}
  }, [esercizi])

  // Il carico/elastico va scelto per la variante attualmente selezionata: si azzera quando
  // si apre un esercizio o si cambia variante, e si precompila di default sull'elastico
  // se quella variante supporta solo l'elastico (mai il peso).
  useEffect(() => {
    if (!dettaglio) return
    const s = livelloScelto || dettaglio
    setCaricoAvvio('')
    setUsaElasticoAvvio(!s.supporta_sovraccarico && !!s.consente_elastico)
    setElasticoAvvio('')
  }, [dettaglio, livelloScelto])

  // Ordine della libreria: prima gli esercizi "base", poi le loro varianti.
  // Su 569 esercizi, 418 sono varianti di altri (es. "Con appoggio (Air Squat)"):
  // in ordine alfabetico affollavano la lista e il primo esercizio che un atleta
  // vedeva era "Ape". L'ordinamento precedente era categoria+nome, e "Animal Flow"
  // è semplicemente la prima categoria in alfabeto: non era una scelta.
  const PRIORITA_CATEGORIA = { 'Corpo libero': 1, Calisthenics: 2, Pesistica: 3, Kettlebell: 4, CrossFit: 5, Cardio: 6, 'Mobilità': 7, 'Animal Flow': 8 }

  function ordinaPerRilevanza(elenco) {
    // Un esercizio è una variante se qualcun altro lo elenca tra varianti o regressioni
    const idVarianti = new Set()
    elenco.forEach(e => {
      ;[...comeLista(e.varianti), ...comeLista(e.regressioni)].forEach(v => {
        if (v?.esercizioId) idVarianti.add(v.esercizioId)
      })
    })
    return [...elenco].sort((a, b) => {
      const va = idVarianti.has(a.id) ? 1 : 0, vb = idVarianti.has(b.id) ? 1 : 0
      if (va !== vb) return va - vb                                   // prima i base
      const ca = PRIORITA_CATEGORIA[a.categoria] || 99, cb = PRIORITA_CATEGORIA[b.categoria] || 99
      if (ca !== cb) return ca - cb                                   // poi per categoria
      return (a.nome || '').localeCompare(b.nome || '', 'it')         // infine per nome
    })
  }

  async function caricaDati() {
    setCaricamento(true)
    const [{ data: ex }, { data: pref }] = await Promise.all([
      supabase.from('esercizi_db').select('*').eq('attivo', true).order('categoria').order('nome'),
      supabase.from('esercizi_preferiti').select('esercizio_id, note_personali, link_video_personale').eq('utente_id', profilo.id)
    ])
    setEsercizi(ordinaPerRilevanza(ex || []))
    setPreferiti(pref || [])
    setCaricamento(false)
  }

  const prefIds = preferiti.map(p => p.esercizio_id)

  async function togglePreferito(esId) {
    if (prefIds.includes(esId)) {
      await supabase.from('esercizi_preferiti').delete().eq('utente_id', profilo.id).eq('esercizio_id', esId)
      setPreferiti(p => p.filter(x => x.esercizio_id !== esId))
      toast_msg('Rimosso dalla lista')
    } else {
      await supabase.from('esercizi_preferiti').insert({ utente_id: profilo.id, esercizio_id: esId })
      setPreferiti(p => [...p, { esercizio_id: esId }])
      toast_msg('✅ Aggiunto alla lista!')
    }
  }

  async function aggiornaNotePref(esId, campo, valore) {
    await supabase.from('esercizi_preferiti').update({ [campo]: valore }).eq('utente_id', profilo.id).eq('esercizio_id', esId)
    setPreferiti(p => p.map(x => x.esercizio_id === esId ? { ...x, [campo]: valore } : x))
  }

  async function salvaEsercizioAdmin() {
    if (!nuovoEx.nome.trim()) { toast_msg('Inserisci il nome'); return }
    const dati = {
      nome: nuovoEx.nome, categoria: nuovoEx.categoria,
      muscoli: nuovoEx.muscoli.split(',').map(m => m.trim()).filter(Boolean),
      qualita: nuovoEx.qualita.split(',').map(q => q.trim()).filter(Boolean),
      tipo_misura: nuovoEx.tipo_misura, supporta_sovraccarico: nuovoEx.supporta_sovraccarico,
      descrizione: nuovoEx.descrizione, difficolta: nuovoEx.difficolta,
      video_url: nuovoEx.video_url || null, attrezzatura: nuovoEx.attrezzatura,
      consente_elastico: nuovoEx.consente_elastico,
    }
    const { error } = modificaId
      ? await supabase.from('esercizi_db').update(dati).eq('id', modificaId)
      : await supabase.from('esercizi_db').insert({ ...dati, varianti: [], regressioni: [] })
    if (error) { toast_msg('Errore: ' + error.message); return }
    toast_msg(modificaId ? '✅ Esercizio aggiornato!' : '✅ Esercizio aggiunto!')
    chiudiFormAdmin()
    caricaDati()
  }

  function apriModificaAdmin(ex) {
    setModificaId(ex.id)
    setNuovoEx({
      nome: ex.nome, categoria: ex.categoria, muscoli: (ex.muscoli || []).join(', '), qualita: (ex.qualita || []).join(', '),
      tipo_misura: ex.tipo_misura, supporta_sovraccarico: !!ex.supporta_sovraccarico,
      descrizione: ex.descrizione || '', difficolta: ex.difficolta || 3,
      video_url: ex.video_url || '', attrezzatura: ex.attrezzatura || [],
      consente_elastico: !!ex.consente_elastico,
    })
    setMostraForm(true)
  }

  function chiudiFormAdmin() {
    setMostraForm(false)
    setModificaId(null)
    setNuovoEx({ nome: '', categoria: 'Corpo libero', muscoli: '', qualita: '', tipo_misura: 'ripetizioni', supporta_sovraccarico: false, descrizione: '', difficolta: 3, video_url: '', attrezzatura: [], consente_elastico: false })
  }

  function toggleAttrezzoForm(a) {
    setNuovoEx(p => ({ ...p, attrezzatura: p.attrezzatura.includes(a) ? p.attrezzatura.filter(x => x !== a) : [...p.attrezzatura, a] }))
  }

  function toast_msg(msg) { setToast(msg); setTimeout(() => setToast(''), 2500) }

  function scegliCategoria(c) {
    setCatFiltro(c)
    setAttrezzoScelto(null)
  }

  const standaloneAttrezzi = !!onAvviaOra && !modalitaScelta && !modaleSelezione

  function apriAttrezzo(a) {
    if (standaloneAttrezzi) {
      const disponibili = esercizi.filter(e => (e.attrezzatura || []).includes(a))
      if (disponibili.length > 0) avviaDaAttrezzo(disponibili[0], disponibili) // ogni attrezzo ha sempre almeno un esercizio collegato
      return
    }
    setAttrezzoScelto(a)
  }

  // Apre la pagina di configurazione (carico o elastico) prima di avviare davvero l'allenamento.
  // Se l'esercizio non ha nulla da configurare, avvia subito senza far perdere tempo.
  function apriAvvio(ex) {
    if (!ex.supporta_sovraccarico && !ex.consente_elastico) {
      onAvviaOra && onAvviaOra(ex, null)
      return
    }
    setEsercizioAvvio(ex)
    setCaricoAvvio('')
    setUsaElasticoAvvio(!ex.supporta_sovraccarico && !!ex.consente_elastico) // se può solo l'elastico, parte già selezionato
    setElasticoAvvio('')
  }

  // Avvio diretto da una pagina Attrezzo: nessun esercizio da attrezzatura usa l'elastico
  // (regola di prodotto), quindi il carico si inserisce già in sessione — si salta la pagina intermedia.
  // Passiamo anche le varianti "sorelle" (stesso attrezzo) così la sessione può offrirle come selettore.
  function avviaDaAttrezzo(ex, disponibili) {
    if (ex.consente_elastico) { apriAvvio(ex); return } // rete di sicurezza, non dovrebbe mai succedere per attrezzi
    const variantiAttrezzo = disponibili.map(d => ({
      id: d.id, nome: d.nome, tipo_misura: d.tipo_misura, attrezzatura: d.attrezzatura || [], consente_elastico: !!d.consente_elastico,
    }))
    onAvviaOra && onAvviaOra(ex, null, null, variantiAttrezzo)
  }

  function chiudiAvvio() {
    setEsercizioAvvio(null)
    setCaricoAvvio('')
    setUsaElasticoAvvio(false)
    setElasticoAvvio('')
  }

  function confermaAvvio() {
    if (!esercizioAvvio) return
    onAvviaOra && onAvviaOra(
      esercizioAvvio,
      !usaElasticoAvvio && caricoAvvio ? Number(caricoAvvio) : null,
      usaElasticoAvvio ? (elasticoAvvio || null) : null
    )
    chiudiAvvio()
  }

  // Avvia direttamente dalla pagina di dettaglio/varianti, usando il carico o elastico già scelto lì:
  // niente più passaggio intermedio, come per gli attrezzi.
  function avviaConCaricoScelto(ex) {
    // Memorizza da quale schermata di dettaglio è partita la sessione, così la freccia indietro
    // (in HomeAtleta.js) riapre esattamente questa pagina di dettaglio e non la lista generale.
    if (dettaglio) sessionStorage.setItem('fp_libreria_riapri_dettaglio', JSON.stringify({ baseId: dettaglio.id, selId: ex.id }))
    onAvviaOra && onAvviaOra(
      ex,
      !usaElasticoAvvio && caricoAvvio ? Number(caricoAvvio) : null,
      usaElasticoAvvio ? (elasticoAvvio || null) : null
    )
  }

  const filtrati = esercizi.filter(e => {
    const matchNav = catFiltro === 'Attrezzi'
      ? (attrezzoScelto ? (e.attrezzatura || []).includes(attrezzoScelto) : false)
      : (!catFiltro || e.categoria === catFiltro)
    const testoCerca = cerca.toLowerCase()
    // La ricerca copre nome, muscoli e qualità atletiche (Cardio, Mobilità, Equilibrio...)
    const matchCerca = !cerca || e.nome.toLowerCase().includes(testoCerca)
      || (e.muscoli || []).some(m => m.toLowerCase().includes(testoCerca))
      || (e.qualita || []).some(q => q.toLowerCase().includes(testoCerca))
    const matchTab = tab === 'miei' ? prefIds.includes(e.id) : true
    return matchNav && matchCerca && matchTab
  })

  // Pagina: esercizi disponibili per l'attrezzo scelto (navigazione vera, non un modale)
  // Pagina: configurazione carico o elastico prima di avviare davvero l'allenamento.
  // Controllata PRIMA della pagina attrezzo: se arrivi qui da lì, quella resta "aperta" sotto
  // (non la richiudiamo), così il tasto indietro ti riporta correttamente all'elenco esercizi
  // dell'attrezzo invece che saltare alla lista principale.
  if (esercizioAvvio) {
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
        <div className="topbar">
          <button className="back-btn" onClick={chiudiAvvio}>←</button>
          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, flex: 1, textAlign: 'center', margin: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{esercizioAvvio.nome}</div>
          <div style={{ width: 32 }} />
        </div>
        <div className="scroll-area">
          <div className="card">
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {esercizioAvvio.supporta_sovraccarico && esercizioAvvio.consente_elastico && (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="button" onClick={() => setUsaElasticoAvvio(false)} style={{ flex: 1, padding: '10px', borderRadius: 10, border: `2px solid ${!usaElasticoAvvio ? 'var(--accent)' : 'var(--border)'}`, background: !usaElasticoAvvio ? 'rgba(200,255,87,0.1)' : 'var(--surface2)', color: !usaElasticoAvvio ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, fontFamily: 'Syne', fontSize: 12, cursor: 'pointer' }}>⚖️ Peso</button>
                  <button type="button" onClick={() => setUsaElasticoAvvio(true)} style={{ flex: 1, padding: '10px', borderRadius: 10, border: `2px solid ${usaElasticoAvvio ? 'var(--accent2)' : 'var(--border)'}`, background: usaElasticoAvvio ? 'rgba(87,184,255,0.1)' : 'var(--surface2)', color: usaElasticoAvvio ? 'var(--accent2)' : 'var(--muted)', fontWeight: 700, fontFamily: 'Syne', fontSize: 12, cursor: 'pointer' }}>🦺 Elastico</button>
                </div>
              )}

              {(!usaElasticoAvvio && esercizioAvvio.supporta_sovraccarico) && (
                <div className="form-group">
                  <label className="form-label">Carico di partenza (kg, facoltativo)</label>
                  <input className="form-input" type="number" inputMode="decimal" placeholder="Es. 40" value={caricoAvvio} onChange={e => setCaricoAvvio(e.target.value)} />
                </div>
              )}

              {(usaElasticoAvvio && esercizioAvvio.consente_elastico) && (
                <div className="form-group">
                  <label className="form-label">Colore elastico</label>
                  <select className="form-select" value={elasticoAvvio} onChange={e => setElasticoAvvio(e.target.value)}>
                    <option value="">-- scegli --</option>
                    {['Giallo (leggero)', 'Verde', 'Rosso', 'Blu', 'Viola', 'Nero (forte)'].map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
              )}

              <button className="btn btn-primary" onClick={confermaAvvio} style={{ fontSize: 15, padding: 14 }}>
                ▶ Inizia allenamento
              </button>
            </div>
          </div>
        </div>
        {toast && <div className="toast">{toast}</div>}
      </div>
    )
  }

  if (attrezzoPagina) {
    const disponibili = esercizi.filter(e => (e.attrezzatura || []).includes(attrezzoPagina))
    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
        <div className="topbar">
          <button className="back-btn" onClick={() => setAttrezzoPagina(null)}>←</button>
          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, flex: 1, textAlign: 'center', margin: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{attrezzoPagina}</div>
          <div style={{ width: 32 }} />
        </div>
        <div className="scroll-area">
          {disponibili.length === 0 ? (
            <div style={{ textAlign: 'center', color: 'var(--muted)', fontSize: 13, padding: '40px 0' }}>Nessun esercizio ancora collegato a questo attrezzo.</div>
          ) : (
            <div className="card">
              <div style={{ padding: '0 16px' }}>
                {disponibili.map((e, i) => (
                  <div key={e.id} onClick={() => avviaDaAttrezzo(e, disponibili)}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0', borderBottom: i < disponibili.length - 1 ? '1px solid var(--border)' : 'none', cursor: 'pointer' }}>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{e.nome}</div>
                      <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap' }}>
                        {(e.muscoli || []).slice(0, 2).map(m => <span key={m} style={{ fontSize: 10, color: 'var(--muted)' }}>{m}</span>)}
                      </div>
                    </div>
                    <div style={{ color: 'var(--muted)', fontSize: 18, flexShrink: 0 }}>›</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {toast && <div className="toast">{toast}</div>}
      </div>
    )
  }

  if (dettaglio) {
    const sel = livelloScelto || dettaglio
    const prefInfo = preferiti.find(p => p.esercizio_id === sel.id)
    // Famiglia di livelli: regressioni (dal più facile) → esercizio base → varianti (dal più difficile)
    // Il collegamento avviene per esercizioId quando presente (link esplicito e univoco); in sua assenza
    // si ricade sul confronto per nome esatto, come sempre, per non rompere i dati già collegati così.
    const trovaRef = (voce) => esercizi.find(e => voce.esercizioId ? e.id === voce.esercizioId : e.nome === voce.nome)
    const famiglia = [
      ...(dettaglio.regressioni || []).slice().reverse().map(r => ({ nome: r.nome, livello: r.livello, ref: trovaRef(r), tipo: 'facile' })),
      { nome: dettaglio.nome, livello: dettaglio.difficolta, ref: dettaglio, tipo: 'base' },
      ...(dettaglio.varianti || []).map(v => ({ nome: v.nome, livello: v.livello, ref: trovaRef(v), tipo: 'difficile' })),
    ]
    const haFamiglia = famiglia.length > 1

    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
        <div className="topbar">
          <button className="back-btn" onClick={() => { setDettaglio(null); setLivelloScelto(null) }}>←</button>
          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14, flex: 1, textAlign: 'center', margin: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sel.nome}</div>
          {isAdmin && (
            <button onClick={() => apriModificaAdmin(sel)} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, padding: '6px 12px', cursor: 'pointer', fontSize: 13, fontWeight: 700, color: 'var(--accent2)', fontFamily: 'Syne', marginRight: 8 }}>
              ✏️
            </button>
          )}
          <button onClick={() => togglePreferito(sel.id)} style={{ background: prefIds.includes(sel.id) ? 'rgba(200,255,87,0.15)' : 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, padding: '6px 12px', cursor: 'pointer', fontSize: 13, fontWeight: 700, color: prefIds.includes(sel.id) ? 'var(--accent)' : 'var(--muted)', fontFamily: 'Syne' }}>
            {prefIds.includes(sel.id) ? '★' : '☆'}
          </button>
        </div>
        <div className="scroll-area">
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <span className="badge badge-accent">{sel.categoria}</span>
            <span className="badge badge-blue">Diff. {sel.difficolta}/10</span>
            <span className={`badge ${sel.tipo_misura === 'tempo' ? 'badge-purple' : 'badge-green'}`}>{sel.tipo_misura === 'tempo' ? '⏱️ A tempo' : '🔢 Ripetizioni'}</span>
            {sel.supporta_sovraccarico && <span className="badge badge-orange">⚖️ Sovraccarico</span>}
          </div>

          {(sel.attrezzatura || []).length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {sel.attrezzatura.map(a => (
                <span key={a} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 10, background: 'rgba(110,168,255,0.12)', color: 'var(--accent2)', fontWeight: 700 }}>🏋️ {a}</span>
              ))}
            </div>
          )}

          {/* Selettore variante: sempre visibile, un solo tocco per scegliere, ben evidente qual è selezionata */}
          {haFamiglia && (
            <div className="card">
              <div className="card-header"><div className="card-title">🎚️ Scegli la variante di esercizio</div></div>
              <div style={{ padding: '0 16px' }}>
                {famiglia.map((f, i) => {
                  const attivo = f.ref && sel.id === f.ref.id
                  return (
                    <div key={i} onClick={() => f.ref && setLivelloScelto(f.ref)}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 10, padding: '12px 8px', margin: '4px 0', borderRadius: 10,
                        border: attivo ? '2px solid var(--accent)' : '1px solid var(--border)',
                        background: attivo ? 'rgba(200,255,87,0.1)' : 'transparent',
                        cursor: f.ref ? 'pointer' : 'default', opacity: f.ref ? 1 : 0.5,
                      }}>
                      <div style={{ width: 20, textAlign: 'center', fontSize: 14, color: attivo ? 'var(--accent)' : 'var(--muted)' }}>{attivo ? '●' : '○'}</div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: attivo ? 700 : 600, color: attivo ? 'var(--accent)' : 'var(--text)' }}>{f.nome}{f.tipo === 'base' ? ' (base)' : ''}</div>
                      </div>
                      <div style={{ fontSize: 11, color: 'var(--muted)', flexShrink: 0 }}>{f.ref ? `Livello ${f.livello}` : 'Non ancora in libreria'}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          )}

          {/* Carico/elastico della variante scelta: si sceglie già qui, non serve più un passaggio a parte */}
          {(sel.supporta_sovraccarico || sel.consente_elastico) && onAvviaOra && !modalitaScelta && !modaleSelezione && (
            <div className="card">
              <div className="card-header"><div className="card-title">⚖️ Scegli il carico</div></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {sel.supporta_sovraccarico && sel.consente_elastico && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button type="button" onClick={() => setUsaElasticoAvvio(false)} style={{ flex: 1, padding: '10px', borderRadius: 10, border: `2px solid ${!usaElasticoAvvio ? 'var(--accent)' : 'var(--border)'}`, background: !usaElasticoAvvio ? 'rgba(200,255,87,0.1)' : 'var(--surface2)', color: !usaElasticoAvvio ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, fontFamily: 'Syne', fontSize: 12, cursor: 'pointer' }}>⚖️ Peso</button>
                    <button type="button" onClick={() => setUsaElasticoAvvio(true)} style={{ flex: 1, padding: '10px', borderRadius: 10, border: `2px solid ${usaElasticoAvvio ? 'var(--accent2)' : 'var(--border)'}`, background: usaElasticoAvvio ? 'rgba(87,184,255,0.1)' : 'var(--surface2)', color: usaElasticoAvvio ? 'var(--accent2)' : 'var(--muted)', fontWeight: 700, fontFamily: 'Syne', fontSize: 12, cursor: 'pointer' }}>🦺 Elastico</button>
                  </div>
                )}
                {(!usaElasticoAvvio && sel.supporta_sovraccarico) && (
                  <div className="form-group">
                    <label className="form-label">Carico di partenza (kg, facoltativo)</label>
                    <input className="form-input" type="number" inputMode="decimal" placeholder="Es. 40" value={caricoAvvio} onChange={e => setCaricoAvvio(e.target.value)} />
                  </div>
                )}
                {(usaElasticoAvvio && sel.consente_elastico) && (
                  <div className="form-group">
                    <label className="form-label">Colore elastico</label>
                    <select className="form-select" value={elasticoAvvio} onChange={e => setElasticoAvvio(e.target.value)}>
                      <option value="">-- scegli --</option>
                      {['Giallo (leggero)', 'Verde', 'Rosso', 'Blu', 'Viola', 'Nero (forte)'].map(c => <option key={c}>{c}</option>)}
                    </select>
                  </div>
                )}
              </div>
            </div>
          )}

          {onAvviaOra && !modalitaScelta && !modaleSelezione && (
            <button className="btn btn-primary" onClick={() => avviaConCaricoScelto(sel)} style={{ fontSize: 15, padding: '14px' }}>
              ▶ Inizia allenamento{sel.id !== dettaglio.id ? ` — ${sel.nome}` : ' con questo esercizio'}
            </button>
          )}

          {sel.descrizione && (
            <div className="card"><div className="card-body" style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7 }}>{sel.descrizione}</div></div>
          )}

          {sel.video_url && (
            <div className="card">
              <div className="card-header"><div className="card-title">🎬 Video tutorial</div></div>
              <div className="card-body">
                <a href={sel.video_url} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent2)', fontSize: 13, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 6 }}>
                  ▶ Guarda su YouTube
                </a>
              </div>
            </div>
          )}

          {(sel.muscoli || []).length > 0 && (
            <div className="card">
              <div className="card-header"><div className="card-title">💪 Muscoli coinvolti</div></div>
              <div className="card-body" style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {sel.muscoli.map(m => <span key={m} className="tag active">{m}</span>)}
              </div>
            </div>
          )}

          {/* Qualità atletiche (Cardio, Mobilità, Equilibrio...): sono cosa allena
              l'esercizio, non quali muscoli usa, quindi stanno in una card a parte */}
          {(sel.qualita || []).length > 0 && (
            <div className="card">
              <div className="card-header"><div className="card-title">⚡ Qualità allenate</div></div>
              <div className="card-body" style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {sel.qualita.map(q => (
                  <span key={q} className="tag" style={{ background: 'rgba(87,184,255,0.12)', borderColor: 'rgba(87,184,255,0.35)', color: 'var(--accent2)' }}>{q}</span>
                ))}
              </div>
            </div>
          )}

          {prefIds.includes(sel.id) && (
            <div className="card">
              <div className="card-header"><div className="card-title">📝 Le mie note</div></div>
              <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div className="form-group">
                  <label className="form-label">Note personali</label>
                  <input className="form-input" placeholder="Annotazioni tecniche, sensazioni..." defaultValue={prefInfo?.note_personali || ''} onBlur={e => aggiornaNotePref(sel.id, 'note_personali', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Il mio video di riferimento</label>
                  <input className="form-input" placeholder="https://youtube.com/..." defaultValue={prefInfo?.link_video_personale || ''} onBlur={e => aggiornaNotePref(sel.id, 'link_video_personale', e.target.value)} />
                </div>
                {prefInfo?.link_video_personale && (
                  <a href={prefInfo.link_video_personale} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--accent2)', fontSize: 13, textDecoration: 'none' }}>▶ Guarda il mio video</a>
                )}
              </div>
            </div>
          )}

          {modalitaScelta
            ? <button className="btn btn-primary" onClick={() => onScelto && onScelto(sel)}>✓ Usa questo esercizio</button>
            : <button className="btn btn-secondary" onClick={() => togglePreferito(sel.id)}>
                {prefIds.includes(sel.id) ? '✕ Rimuovi dalla lista' : '★ Aggiungi alla lista'}
              </button>
          }
        </div>
        {toast && <div className="toast">{toast}</div>}
      </div>
    )
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      {!onChiudi ? (
        <>
          <TopBar />
          <div style={{ padding: '10px 20px 2px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
            <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>Esercizi</div>
            {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => { chiudiFormAdmin(); setMostraForm(true) }} style={{ position: 'absolute', right: 20 }}>+ Nuovo</button>}
          </div>
        </>
      ) : (
        <div className="topbar">
          <button className="back-btn" onClick={onChiudi}>←</button>
          <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16 }}>Esercizi</div>
          {isAdmin ? <button className="btn btn-primary btn-sm" onClick={() => { chiudiFormAdmin(); setMostraForm(true) }}>+ Nuovo</button> : <div style={{ width: 32 }} />}
        </div>
      )}

      <div className="scroll-area">
        {mostraForm && isAdmin && (
          <div className="card slide-up">
            <div className="card-header">
              <div className="card-title">{modificaId ? '✏️ Modifica esercizio' : '➕ Nuovo esercizio'}</div>
              <button onClick={chiudiFormAdmin} style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 18 }}>✕</button>
            </div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group"><label className="form-label">Nome *</label><input className="form-input" value={nuovoEx.nome} onChange={e => setNuovoEx(p => ({ ...p, nome: e.target.value }))} placeholder="es. Push-up" /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div className="form-group">
                  <label className="form-label">Categoria</label>
                  <select className="form-select" value={nuovoEx.categoria} onChange={e => setNuovoEx(p => ({ ...p, categoria: e.target.value }))}>
                    {CATEGORIE.map(c => <option key={c}>{c}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Misura</label>
                  <select className="form-select" value={nuovoEx.tipo_misura} onChange={e => setNuovoEx(p => ({ ...p, tipo_misura: e.target.value }))}>
                    <option value="ripetizioni">Ripetizioni</option>
                    <option value="tempo">Tempo</option>
                    <option value="distanza">Distanza</option>
                  </select>
                </div>
              </div>
              <div className="form-group"><label className="form-label">Muscoli (separati da virgola)</label><input className="form-input" value={nuovoEx.muscoli} onChange={e => setNuovoEx(p => ({ ...p, muscoli: e.target.value }))} placeholder="Petto, Tricipiti" /></div>
              <div className="form-group"><label className="form-label">Qualità allenate (separate da virgola)</label><input className="form-input" value={nuovoEx.qualita} onChange={e => setNuovoEx(p => ({ ...p, qualita: e.target.value }))} placeholder="Cardio, Mobilità, Equilibrio" /></div>
              <div className="form-group">
                <label className="form-label">Attrezzatura sala pesi (facoltativa)</label>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {ATTREZZATURE.map(a => (
                    <button key={a} type="button" onClick={() => toggleAttrezzoForm(a)} className="tag"
                      style={nuovoEx.attrezzatura.includes(a) ? { background: 'rgba(110,168,255,0.15)', borderColor: 'var(--accent2)', color: 'var(--accent2)' } : {}}>
                      {a}
                    </button>
                  ))}
                </div>
              </div>
              <div className="form-group"><label className="form-label">Descrizione</label><input className="form-input" value={nuovoEx.descrizione} onChange={e => setNuovoEx(p => ({ ...p, descrizione: e.target.value }))} placeholder="Descrizione tecnica..." /></div>
              <div className="form-group"><label className="form-label">Video YouTube (URL)</label><input className="form-input" value={nuovoEx.video_url} onChange={e => setNuovoEx(p => ({ ...p, video_url: e.target.value }))} placeholder="https://youtube.com/..." /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div className="form-group"><label className="form-label">Difficoltà (1-10)</label><input className="num-input" type="number" min={1} max={10} value={nuovoEx.difficolta} onChange={e => setNuovoEx(p => ({ ...p, difficolta: +e.target.value }))} /></div>
                <div className="form-group">
                  <label className="form-label">Sovraccarico</label>
                  <button type="button" onClick={() => setNuovoEx(p => ({ ...p, supporta_sovraccarico: !p.supporta_sovraccarico }))} style={{ padding: '12px', borderRadius: 10, border: '2px solid', borderColor: nuovoEx.supporta_sovraccarico ? 'var(--accent)' : 'var(--border)', background: nuovoEx.supporta_sovraccarico ? 'rgba(200,255,87,0.1)' : 'var(--surface2)', color: nuovoEx.supporta_sovraccarico ? 'var(--accent)' : 'var(--muted)', fontWeight: 700, cursor: 'pointer', fontSize: 12, fontFamily: 'Syne', width: '100%' }}>
                    {nuovoEx.supporta_sovraccarico ? '✓ Sì' : 'No'}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">🦺 Elastico di assistenza</label>
                <button type="button" onClick={() => setNuovoEx(p => ({ ...p, consente_elastico: !p.consente_elastico }))} style={{ padding: '12px', borderRadius: 10, border: '2px solid', borderColor: nuovoEx.consente_elastico ? 'var(--accent2)' : 'var(--border)', background: nuovoEx.consente_elastico ? 'rgba(87,184,255,0.1)' : 'var(--surface2)', color: nuovoEx.consente_elastico ? 'var(--accent2)' : 'var(--muted)', fontWeight: 700, cursor: 'pointer', fontSize: 12, fontFamily: 'Syne', width: '100%' }}>
                  {nuovoEx.consente_elastico ? '✓ Sì, mostra l\'opzione elastico' : 'No'}
                </button>
                <div style={{ fontSize: 10, color: 'var(--muted)', marginTop: 4 }}>Attivalo solo per esercizi a corpo libero dove l'elastico di assistenza è una tecnica reale (trazioni, dip, muscle-up...). Mai per esercizi con attrezzatura a carico regolabile.</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <button className="btn btn-secondary" onClick={chiudiFormAdmin}>Annulla</button>
                <button className="btn btn-primary" onClick={salvaEsercizioAdmin}>{modificaId ? 'Salva modifiche' : 'Salva'}</button>
              </div>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: 6 }}>
          {[{ id: 'tutti', label: `Tutti (${esercizi.length})` }, { id: 'miei', label: `La mia lista (${prefIds.length})` }].map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} className={`tag ${tab === t.id ? 'active' : ''}`} style={{ flex: 1, justifyContent: 'center' }}>{t.label}</button>
          ))}
        </div>

        <input className="form-input" placeholder="🔍 Cerca esercizio o muscolo..." value={cerca} onChange={e => setCerca(e.target.value)} />

        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <button onClick={() => scegliCategoria(null)} className={`tag ${!catFiltro ? 'active' : ''}`}>Tutte</button>
          {CATEGORIE.map(c => (
            <button key={c} onClick={() => scegliCategoria(catFiltro === c ? null : c)} className="tag"
              style={catFiltro === c ? { background: COL[c]?.bg, borderColor: COL[c]?.text, color: COL[c]?.text } : {}}>{c}</button>
          ))}
          <button onClick={() => scegliCategoria(catFiltro === 'Attrezzi' ? null : 'Attrezzi')} className="tag"
            style={catFiltro === 'Attrezzi' ? { background: 'rgba(110,168,255,0.15)', borderColor: 'var(--accent2)', color: 'var(--accent2)' } : {}}>
            🏋️ Attrezzi
          </button>
        </div>

        {catFiltro === 'Attrezzi' && !attrezzoScelto ? (
          <div className="card fade-in">
            <div style={{ padding: '0 16px' }}>
              {ATTREZZATURE.filter(a => !cerca || a.toLowerCase().includes(cerca.toLowerCase())).map((a, i, arr) => (
                <div key={a} onClick={() => apriAttrezzo(a)}
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none', cursor: 'pointer' }}>
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{a}</div>
                  <div style={{ color: 'var(--muted)', fontSize: 18 }}>›</div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {catFiltro === 'Attrezzi' && attrezzoScelto && (
              <button onClick={() => setAttrezzoScelto(null)} className="tag" style={{ alignSelf: 'flex-start' }}>‹ {attrezzoScelto}</button>
            )}
            {caricamento ? (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 30 }}>Caricamento...</div>
            ) : filtrati.length === 0 ? (
              <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 30, fontSize: 13 }}>
                {tab === 'miei' ? 'Nessun esercizio nella tua lista.\nUsa ☆ per aggiungerne.' : 'Nessun esercizio trovato'}
              </div>
            ) : (
          <div className="card">
            <div style={{ padding: '0 16px' }}>
              {filtrati.map((e, i) => (
                <div key={e.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: i < filtrati.length - 1 ? '1px solid var(--border)' : 'none' }}>
                  <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => modalitaScelta ? (onScelto && onScelto(e)) : (setDettaglio(e), setLivelloScelto(e))}>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>{e.nome}</div>
                    <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap', alignItems: 'center' }}>
                      <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: COL[e.categoria]?.bg || 'var(--surface2)', color: COL[e.categoria]?.text || 'var(--muted)', fontWeight: 700 }}>{e.categoria}</span>
                      {(e.muscoli || []).slice(0, 2).map(m => <span key={m} style={{ fontSize: 10, color: 'var(--muted)' }}>{m}</span>)}
                      {(e.attrezzatura || []).length > 0 && <span style={{ fontSize: 10, color: 'var(--accent2)' }}>🏋️</span>}
                      {e.video_url && <span style={{ fontSize: 10, color: 'var(--accent2)' }}>▶</span>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                    {(modaleSelezione || modalitaScelta) && (
                      <button onClick={ev => { ev.stopPropagation(); togglePreferito(e.id) }} title={prefIds.includes(e.id) ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti'}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: prefIds.includes(e.id) ? 'var(--accent)' : 'var(--muted)', transition: 'color 0.2s', padding: 4 }}>
                        {prefIds.includes(e.id) ? '★' : '☆'}
                      </button>
                    )}
                    {modaleSelezione ? (
                      <button
                        className="btn btn-sm"
                        onClick={() => esercizioSelezionato && esercizioSelezionato(e)}
                        style={{
                          background: esercizioSelezionatoIds.includes(e.id) ? 'rgba(74,222,128,0.15)' : 'var(--accent)',
                          color: esercizioSelezionatoIds.includes(e.id) ? 'var(--green)' : '#000',
                          border: esercizioSelezionatoIds.includes(e.id) ? '1px solid rgba(74,222,128,0.3)' : 'none',
                          minWidth: 60, flexShrink: 0,
                        }}
                      >
                        {esercizioSelezionatoIds.includes(e.id) ? '✓' : '+ Add'}
                      </button>
                    ) : !modalitaScelta ? (
                      <button onClick={() => togglePreferito(e.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: prefIds.includes(e.id) ? 'var(--accent)' : 'var(--muted)', transition: 'color 0.2s', flexShrink: 0 }}>
                        {prefIds.includes(e.id) ? '★' : '☆'}
                      </button>
                    ) : (
                      <button className="btn btn-primary btn-sm" onClick={() => onScelto && onScelto(e)}>+ Add</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
            )}
          </>
        )}
      </div>
      {toast && <div className="toast">{toast}</div>}

    </div>
  )
}
